import { CLASSNAME_HIDDEN } from '@vfde-brix/ws10/styles';
import { AppId, CaptchaId, LmsAddressInputId } from '../../../enums/elementId';
import { Address } from '../interface';
import { FormElement } from '@vfde-brix/ws10/form-element';

const getAddressValueByInput = (address: Address, input: LmsAddressInputId): string => {
    switch (input) {
        case LmsAddressInputId.INPUT_CITY: return address.city ?? '';
        case LmsAddressInputId.INPUT_STREET: return address.street;
        case LmsAddressInputId.INPUT_HOUSE: return `${address.housenumber}${address.housenumberextra ?? ''}`;
        case LmsAddressInputId.INPUT_ZIP: return address.zipcode ?? '';
    }
};

export const updateAddressInputs = (elements: FormElement[], address: Address) => {
    const inputIds = [
        LmsAddressInputId.INPUT_CITY,
        LmsAddressInputId.INPUT_STREET,
        LmsAddressInputId.INPUT_HOUSE,
        LmsAddressInputId.INPUT_ZIP,
    ];

    for (const id of inputIds) {
        const element = elements.find(el => el.getPropertyByKey('stdId') === id);

        element?.update({ stdValue: getAddressValueByInput(address, id) });
    }
};

export const showForm = () => {
    // show form
    document.getElementById(AppId.ID_WRAPPER_LMS_FORM)?.classList.remove(CLASSNAME_HIDDEN);
    // hide result notification
    document.getElementById(AppId.ID_WRAPPER_NOTIFICATION_RESULT)?.classList.add(CLASSNAME_HIDDEN);
    // always clear captcha input
    const resultElement = document.getElementById(CaptchaId.INPUT_CAPTCHA_RESULT);

    if (resultElement) {
        (resultElement as HTMLInputElement).value = '';
    }
};
